<!--Define Constraints Section-->
<div class="container">
  <div class="offset-1 col-10">

    <div class=" card card-chart">
      <div class=" card-header">
        <div class=" row">
          <div class=" col-sm-6 text-left">
            <h5 class=" card-category">Investment Solution</h5>
            <h2 class=" card-title"><i class="fas fa-cubes fa-lg"></i>&nbsp;&nbsp;&nbsp; Define Contraints</h2>
          </div>
          <div class=" col-sm-6">
            <div *ngIf="!currentCluster.is_standalone" class=" btn-group float-right">
              <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage1=='budget'}"
                      (click)="selectedPage1='budget'">Budget</label>
              <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage1=='weights'}"
                      (click)="selectedPage1='weights'"
                      *ngIf="investableParameters.components.length>0">Weights</label>
              <label [ngClass]="{'btn btn-sm btn-primary':true, 'selected':selectedPage1=='bestFit'}"
                      (click)="selectedPage1='bestFit'">Completeness</label>
            </div>
          </div>
        </div>
      </div>
      <div class=" card-body">
        <div *ngIf="selectedPage1=='budget'">
          <div class="row text-center mt-2">
            <div class="col-6" *ngIf="currentCluster.nb_components>0">
              <span class="mx-2">Allowed Turnover</span>
            </div>
            <div [ngClass]="{'col-6':true, 'offset-3':currentCluster.nb_components==0}">
              <span class="mx-2">Additional Cash</span>
            </div>
          </div>
          <div class="row">
            <div class="col-5 mx-auto" *ngIf="currentCluster.nb_components>0">
              <mat-slider thumbLabel class="w-100"
                          [displayWith]="formatLabel"
                          [(value)]="investableParameters.trading_budget"
                          [step]="0.001"
                          [tickInterval]="0.1"
                          [min]="investableParameters.trading_budget_min"
                          [max]="investableParameters.trading_budget_max"></mat-slider>
            </div>
            <div class="col-5 mx-auto">
              <mat-slider thumbLabel class="w-100"
                          [displayWith]="formatLabel"
                          [(value)]="investableParameters.additional_cash"
                          [step]="0.001"
                          [tickInterval]="0.1"
                          [min]="investableParameters.additional_cash_min"
                          [max]="investableParameters.additional_cash_max"></mat-slider>
            </div>
          </div>
          <div class="row text-center mt-2">
            <div class="col-6" *ngIf="currentCluster.nb_components>0">
              <span class="mx-2">{{ investableParameters.trading_budget | percent:'.1' }}</span>
            </div>
            <div [ngClass]="{'col-6':true, 'offset-3':currentCluster.nb_components==0}">
              <span class="mx-2">{{ investableParameters.additional_cash | percent:'.1' }}</span>
            </div>
          </div>
        </div>

        <div *ngIf="selectedPage1=='weights'">
          <!-- Contribution table -->
          <table *ngIf="investableParameters.components.length>0" mdbTable small="true" hover="true">
            <thead>
              <tr>
                <th scope="col" width="30%">Components</th>
                <th scope="col">Alpha<br>Contribution</th>
                <th scope="col">Weight</th>
                <th scope="col">Min</th>
                <th scope="col">Max</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let component of investableParameters.components">
                <th class="casino" scope="row">{{ component.name }}</th>
                <td>{{ component.alpha | percent:'.1' }}</td>
                <td>{{ component.weight | percent:'.1' }}</td>
                <td><span>{{ component.min_weight | percent:'.1' }}</span><br>
                  <mat-slider thumbLabel class="w-50" style="margin-top: -15px"
                              [displayWith]="formatLabel"
                              [(value)]="component.min_weight"
                              (change)="onConstraintValueChange()"
                              [step]="0.001"
                              [min]="0" [max]="1"></mat-slider>
                </td>
                <td><span>{{ component.max_weight | percent:'.1' }}</span><br>
                  <mat-slider thumbLabel class="w-50" style="margin-top: -15px"
                              [displayWith]="formatLabel"
                              [(value)]="component.max_weight"
                              (change)="onConstraintValueChange()"
                              [step]="0.001"
                              [min]="0" [max]="1"></mat-slider>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- Contribution table -->
          <div class="row text-center mt-2">
            <div class="col-6">
              <app-line-button blue (click)="removeConstraints()">Remove all constraints</app-line-button>
            </div>
            <div class="col-6">
              <app-line-button blue (click)="lessMoreFivePct()">-/+ 5% on all weights</app-line-button>
            </div>
          </div>
        </div>

        <div [ngClass]="{'d-none':selectedPage1!='bestFit'}">
          <div class="row">
            <div class="col-4 text-center" style="line-height: 30px">
              <span class="card-text">Selection &nbsp;&nbsp;&nbsp;
                <mat-form-field>
                  <mat-select [(value)]="bestFitSelection" (selectionChange)="bestFitSelectionChange()">
                    <mat-option value="top18">Top 18</mat-option>
                    <mat-option value="watchlists" [disabled]="watchlists==undefined || watchlists.length==0">Watchlists</mat-option>
                    <mat-option value="selected">Show selected only</mat-option>
                    <mat-option value="all">All</mat-option>
                  </mat-select>
                </mat-form-field>
              </span>
              <br>
            </div>
            <div class="col-4 text-center" style="line-height: 30px">
              <span class="card-text">View &nbsp;&nbsp;&nbsp;
                <mat-form-field>
                  <mat-select value="factor-intensity" (selectionChange)="bestFitViewChange($event.value)">
                    <mat-option value="factor-intensity">Factor Intensity</mat-option>
                    <mat-option value="returns">Returns</mat-option>
                    <mat-option value="sharpe-ratio">Sharpe ratio</mat-option>
                    <mat-option value="max-drawdown">Max Drawdown</mat-option>
                    <mat-option value="esg">ESG</mat-option>
                  </mat-select>
                </mat-form-field>
              </span>
            </div>
            <div class="col-4 text-center" style="line-height: 30px">
              <mat-form-field *ngIf="bestFitSelection=='all'">
                <mat-label>Filter</mat-label>
                <input matInput (keyup)="applyFilter($event)" placeholder="Ex. Diversified">
              </mat-form-field>
              <mat-form-field *ngIf="bestFitSelection=='watchlists'">
                <mat-select [(value)]="selectedWatchlist" (selectionChange)="bestFitSelectionChange()">
                  <mat-option *ngFor="let watchlist of watchlists" [value]="watchlist">{{ watchlist.name }}</mat-option>
                </mat-select>
              </mat-form-field>
              <br>
            </div>
          </div>

          <!-- Table -->
          <div>
            <table mat-table [dataSource]="dataSource" matSort>

              <!-- Checkbox Column -->
              <ng-container matColumnDef="select">
                <th class="checkbox-cell" mat-header-cell *matHeaderCellDef></th>
                <td class="checkbox-cell" mat-cell *matCellDef="let row">
                  <mat-checkbox (change)="onProductSelectionChange($event, row)"
                                [checked]="selection.isSelected(row)">
                  </mat-checkbox>
                </td>
              </ng-container>

              <!-- Frequency Column -->
              <ng-container matColumnDef="frequency">
                <th class="center-header" mat-header-cell *matHeaderCellDef mat-sort-header style="width:30px"></th>
                <td mat-cell *matCellDef="let element">
                  <app-frequency-badge [frequency]="element.frequency.alias"></app-frequency-badge>
                </td>
              </ng-container>

              <!-- Name Column -->
              <ng-container matColumnDef="name">
                <th class="center-header" mat-header-cell *matHeaderCellDef mat-sort-header>Name</th>
                <td class="ellipsis" mat-cell *matCellDef="let element">
                  <span mdbTooltip="{{ element.name }}">{{ element.name }}</span>
                </td>
              </ng-container>

              <!-- Currency Column -->
              <ng-container matColumnDef="currency">
                <th class="center-header" mat-header-cell *matHeaderCellDef style="width:90px">Currency</th>
                <td mat-cell *matCellDef="let element" style="width:90px">{{ element.currency.alias }}</td>
              </ng-container>

              <!-- Investment Zone Column -->
              <ng-container matColumnDef="investment_zone">
                <th class="center-header" mat-header-cell *matHeaderCellDef style="width:120px">Zone</th>
                <td mat-cell *matCellDef="let element" style="width:120px">{{ element.investment_zone.name }}</td>
              </ng-container>

              <!-- Intensity Column -->
              <ng-container matColumnDef="factor_intensity">
                <th class="center-header" mat-header-cell *matHeaderCellDef mat-sort-header style="width:90px">Intensity</th>
                <td mat-cell *matCellDef="let element" style="width:90px">{{ element.factor_intensity | number:'1.3-3' }}</td>
              </ng-container>

              <!-- Returns Column -->
              <ng-container matColumnDef="returns">
                <th class="center-header" mat-header-cell *matHeaderCellDef mat-sort-header style="width:90px">Returns</th>
                <td mat-cell *matCellDef="let element" style="width:90px">{{ element.returns | percent:'.1' }}</td>
              </ng-container>

              <!-- Sharpe ratio Column -->
              <ng-container matColumnDef="sharpe_ratio">
                <th class="center-header" mat-header-cell *matHeaderCellDef mat-sort-header style="width:90px">Sharpe ratio</th>
                <td mat-cell *matCellDef="let element" style="width:90px">{{ element.sharpe_ratio | percent:'.1' }}</td>
              </ng-container>

              <!-- Max Drawdown Column -->
              <ng-container matColumnDef="maximum_drawdown">
                <th class="center-header" mat-header-cell *matHeaderCellDef mat-sort-header style="width:90px">Drawdown</th>
                <td mat-cell *matCellDef="let element" style="width:90px">{{ element.maximum_drawdown | percent:'.1' }}</td>
              </ng-container>

              <!-- ESG Column -->
              <ng-container matColumnDef="esg">
                <th class="center-header" mat-header-cell *matHeaderCellDef mat-sort-header style="width:90px">ESG</th>
                <td mat-cell *matCellDef="let element" style="width:90px">{{ element.esg | number:'1.0-0' }}</td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>

            <mat-paginator [pageSizeOptions]="[10,20,50]" showFirstLastButtons></mat-paginator>
          </div>
          <!-- Table -->

        </div>
      </div>
      <div *ngIf="selectedPage1=='bestFit'" class=" card-footer">
        <!-- Run Optimization button -->
        <div class="row">
          <div class="col text-center">
            <app-button [disabled]="!(investableParameters.completeness_products.length>1)" (click)="onChangeBlock('computation')">Go to optimization</app-button>
          </div>
        </div>
      </div>
    </div>
    <br>

  </div>
</div>
<!--Define Constraints Section-->
